(function () {
  var d = document, html = d.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!('IntersectionObserver' in window)) return;
  html.classList.add('ss-js');

  /* 1. Fuse: red scroll-progress line */
  var fuse = d.createElement('div');
  fuse.className = 'ss-fuse';
  fuse.setAttribute('aria-hidden', 'true');
  d.body.appendChild(fuse);

  /* 2. Mark elements to reveal (staggered within groups) */
  function mark(sel, cls, stagger) {
    var els = d.querySelectorAll(sel);
    for (var i = 0; i < els.length; i++) {
      els[i].classList.add('fx', cls || 'fx-up');
      if (stagger) els[i].style.setProperty('--fx-d', (i % 8) * stagger + 'ms');
    }
  }
  mark('.ss-section-head, .ss-story__label, .ss-case__head', 'fx-up');
  mark('.ss-fact', 'fx-up', 90);
  mark('.ss-ticket', 'fx-up', 110);
  mark('.ss-product', 'fx-up', 110);
  mark('.ss-story__body', 'fx-paper');
  mark('.ss-story__body p, .ss-author .ss-type p', 'fx-redact', 160);
  mark('.ss-author__photo', 'fx-develop');
  mark('.ss-author__copy', 'fx-up');
  mark('.ss-classified, .ss-stamp', 'fx-stamp');
  mark('.ss-center, .ss-author__copy .ss-btn', 'fx-up');
  mark('.main-page-title, .page-width--narrow .rte h2', 'fx-up');

  /* 3. Count-up numbers in the case file */
  function countUp(el) {
    if (el.dataset.counted) return;
    el.dataset.counted = '1';
    var txt = el.textContent, m = txt.match(/\$?([\d,]{3,})/);
    if (!m || reduce) return;
    var target = parseInt(m[1].replace(/,/g, ''), 10);
    if (target >= 1900 && target <= 2030 && m[0].indexOf('$') < 0 && !/pages/i.test(txt)) return;
    var start = null, dur = 1400, pre = txt.slice(0, m.index), post = txt.slice(m.index + m[0].length), dollar = m[0][0] === '$' ? '$' : '';
    function step(t) {
      if (!start) start = t;
      var p = Math.min((t - start) / dur, 1), e = 1 - Math.pow(1 - p, 3);
      el.textContent = pre + dollar + Math.round(target * e).toLocaleString('en-US') + post;
      if (p < 1) requestAnimationFrame(step); else el.textContent = txt;
    }
    requestAnimationFrame(step);
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      var el = en.target;
      el.classList.add('fx-in');
      setTimeout(function () { el.classList.add('fx-done'); }, 1700 + (parseInt(el.style.getPropertyValue('--fx-d') || 0, 10)));
      if (el.classList.contains('ss-fact')) {
        var dd = el.querySelector('dd');
        if (dd) setTimeout(function () { countUp(dd); }, parseInt(el.style.getPropertyValue('--fx-d') || 0, 10));
      }
      io.unobserve(el);
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
  var all = d.querySelectorAll('.fx');
  for (var i = 0; i < all.length; i++) io.observe(all[i]);

  /* 4. Scroll-linked motion */
  var hero = d.querySelector('.ss-hero'),
      card = d.querySelector('.ss-evidence'),
      letters = d.querySelectorAll('.ss-ransom i'),
      ticker = d.querySelector('.ss-ticker__track'),
      seeds = [], lastY = window.scrollY, vel = 0, ticking = false;
  for (var k = 0; k < letters.length; k++) seeds.push([(Math.random() - .5) * 2, (Math.random() - .5) * 2]);
  var ransom = d.querySelector('.ss-ransom');
  if (ransom) setTimeout(function () { ransom.classList.add('is-settled'); }, 1600);

  function frame() {
    ticking = false;
    var y = window.scrollY, h = d.documentElement.scrollHeight - window.innerHeight;
    fuse.style.transform = 'scaleX(' + (h > 0 ? Math.min(y / h, 1) : 0) + ')';
    vel = vel * 0.8 + (y - lastY) * 0.2; lastY = y;
    if (reduce || !hero) return;
    var hh = hero.offsetHeight;
    if (y < hh * 1.2) {
      var p = y / hh;
      if (card) card.style.transform = 'translate3d(0,' + (y * 0.18) + 'px,0) rotate(' + (3 + p * 6) + 'deg)';
      for (var i = 0; i < letters.length; i++) {
        letters[i].style.translate = (seeds[i][0] * p * 40) + 'px ' + (seeds[i][1] * p * 26 - p * 10) + 'px';
      }
    }
    if (ticker) ticker.style.setProperty('--skew', Math.max(-8, Math.min(8, vel * 0.4)) + 'deg');
    if (Math.abs(vel) > 0.1) req();
  }
  function req() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
  window.addEventListener('scroll', req, { passive: true });
  window.addEventListener('resize', req);
  frame();

  /* 5. Cards tilt toward the cursor (mouse devices only) */
  if (!reduce && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    var cards = d.querySelectorAll('.ss-product__media, .ss-ticket');
    Array.prototype.forEach.call(cards, function (c) {
      c.addEventListener('mousemove', function (e) {
        var r = c.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, yy = (e.clientY - r.top) / r.height - .5;
        c.style.transform = 'perspective(700px) rotateY(' + (x * 10) + 'deg) rotateX(' + (-yy * 10) + 'deg) translateY(-4px)';
      });
      c.addEventListener('mouseleave', function () { c.style.transform = ''; });
    });
  }
})();